export * from './user-alert-history-table/user-alert-history-table.component';
